"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PortfolioType;
(function (PortfolioType) {
    PortfolioType["benchmark"] = "benchmark";
    PortfolioType["standard"] = "standard";
})(PortfolioType = exports.PortfolioType || (exports.PortfolioType = {}));
//# sourceMappingURL=PortfolioType.js.map